import React from 'react';

import Tab from '../../../components/Tab';
import Table from '../../../components/Table';

const availabilityFieldNames = {
  internetAccessInLibrary: 'Library',
  internetAccessOnCentralCampus: 'Central Campus',
  internetAccessInResidenceHalls: 'Residence Halls',
  wirelessInternetAccess: 'Wireless',
};

export default function ComputingResources({ computingResources }) {
  const {
    numberOfPCsInComputerCenters,
    numberOfMacsInComputerCenters,
    numberOfPCsInResidences,
    numberOfMacsInResidences,
    numberOfPCsInOther,
    numberOfMacsInOther,
    numberOfPCsInStudentCenters,
    numberOfMacsInStudentCenters,
    numberOfPCsInLibraries,
    numberOfMacsInLibraries,
    numberOfPCsInDepartmentLabs,
    numberOfMacsInDepartmentLabs,
    computerRequired,
    computerRequiredReason,
    computerPurchaseOffered,
    preferredComputerType,
  } = computingResources;
  const internetAvailability = Object.keys(availabilityFieldNames)
    .filter((key) => computingResources[key] && computingResources[key].value === true)
    .map((key) => availabilityFieldNames[key]);
  return (
    <Tab.Pane>
      <Table
        columns={3}
        unstackable
        className="computing-resources-table"
        data-cy="organizations-services-computing-resources-table"
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Computer Location</Table.HeaderCell>
            <Table.HeaderCell>Number of PCs</Table.HeaderCell>
            <Table.HeaderCell>Number of Macs</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row key="cr-location-computer-centers">
            <Table.Cell>Computer Centers</Table.Cell>
            <Table.Cell>
              {!numberOfPCsInComputerCenters || isNaN(numberOfPCsInComputerCenters.value)
                ? '-'
                : numberOfPCsInComputerCenters.value}
            </Table.Cell>
            <Table.Cell>
              {!numberOfMacsInComputerCenters ||
              isNaN(numberOfMacsInComputerCenters.value)
                ? '-'
                : numberOfMacsInComputerCenters.value}
            </Table.Cell>
          </Table.Row>
          <Table.Row key="cr-location-residence">
            <Table.Cell>Residence</Table.Cell>
            <Table.Cell>
              {!numberOfPCsInResidences || isNaN(numberOfPCsInResidences.value)
                ? '-'
                : numberOfPCsInResidences.value}
            </Table.Cell>
            <Table.Cell>
              {!numberOfMacsInResidences || isNaN(numberOfMacsInResidences.value)
                ? '-'
                : numberOfMacsInResidences.value}
            </Table.Cell>
          </Table.Row>
          <Table.Row key="cr-location-other">
            <Table.Cell>Other</Table.Cell>
            <Table.Cell>
              {!numberOfPCsInOther || isNaN(numberOfPCsInOther.value)
                ? '-'
                : numberOfPCsInOther.value}
            </Table.Cell>
            <Table.Cell>
              {!numberOfMacsInOther || isNaN(numberOfMacsInOther.value)
                ? '-'
                : numberOfMacsInOther.value}
            </Table.Cell>
          </Table.Row>
          <Table.Row key="cr-location-student-centers">
            <Table.Cell>Student Centers</Table.Cell>
            <Table.Cell>
              {!numberOfPCsInStudentCenters || isNaN(numberOfPCsInStudentCenters.value)
                ? '-'
                : numberOfPCsInStudentCenters.value}
            </Table.Cell>
            <Table.Cell>
              {!numberOfMacsInStudentCenters || isNaN(numberOfMacsInStudentCenters.value)
                ? '-'
                : numberOfMacsInStudentCenters.value}
            </Table.Cell>
          </Table.Row>
          <Table.Row key="cr-location-library">
            <Table.Cell>Library</Table.Cell>
            <Table.Cell>
              {!numberOfPCsInLibraries || isNaN(numberOfPCsInLibraries.value)
                ? '-'
                : numberOfPCsInLibraries.value}
            </Table.Cell>
            <Table.Cell>
              {!numberOfMacsInLibraries || isNaN(numberOfMacsInLibraries.value)
                ? '-'
                : numberOfMacsInLibraries.value}
            </Table.Cell>
          </Table.Row>
          <Table.Row key="cr-location-department-labs">
            <Table.Cell>Department Labs</Table.Cell>
            <Table.Cell>
              {!numberOfPCsInDepartmentLabs || isNaN(numberOfPCsInDepartmentLabs.value)
                ? '-'
                : numberOfPCsInDepartmentLabs.value}
            </Table.Cell>
            <Table.Cell>
              {!numberOfMacsInDepartmentLabs || isNaN(numberOfMacsInDepartmentLabs.value)
                ? '-'
                : numberOfMacsInDepartmentLabs.value}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      <div>
        <div
          className="computing-resources-policies"
          data-cy="computing-resources-policies"
        >
          <h2>Policies</h2>
          <ul>
            {computerRequired && computerRequired.value && (
              <li>
                Computer Required{' '}
                {computerRequiredReason.value && (
                  <span>({computerRequiredReason.value})</span>
                )}
              </li>
            )}
            {computerPurchaseOffered && computerPurchaseOffered.value && (
              <li>Computer Purchase Offered</li>
            )}
            {preferredComputerType && preferredComputerType.value !== null && (
              <li>Preferred Computer Type: {preferredComputerType.value}</li>
            )}
          </ul>
        </div>
        <div
          className="computing-resources-internet-access"
          data-cy="computing-resources-internet-access"
        >
          <h2>Internet Access Availability</h2>
          <ul>
            {internetAvailability.map((availability) => (
              <li key={availability}>{availability}</li>
            ))}
          </ul>
        </div>
      </div>
    </Tab.Pane>
  );
}
